var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v("KENI! Some inline style on the select")]),
    _vm._v(" "),
    _c("section", [
      !_vm.loading && !_vm.editing
        ? _c("div", [
            _c("table", { staticClass: "table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Ticket")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Sold")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Allocated")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Lost spaces")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Sales moved")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Sales received")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Available Spaces")]),
                  _vm._v(" "),
                  !_vm.editing ? _c("th", [_vm._v("Actions")]) : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.event.tickets, function(ticket) {
                  return _c("tr", [
                    _c("td", [
                      _vm._v(_vm._s(ticket.ticket_data.lang.en_GB.title))
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(ticket.sale_contents.length))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(ticket.allocated))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.getWastageSpaces(ticket)))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.getWastageMoved(ticket)))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.getWastageReceived(ticket)))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.getAvailableSpaces(ticket)) +
                          "\n\t\t\t\t\t\t"
                      ),
                      ticket.season_moved_sales
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v("Sales were transfer only for this event")
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    !_vm.editing
                      ? _c("td", [
                          _vm.ticketHasWastageActive(ticket)
                            ? _c("div", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-danger",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        _vm.finishWastage(ticket)
                                      }
                                    }
                                  },
                                  [_vm._v("Finish Wastage")]
                                )
                              ])
                            : _c("div", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        _vm.addWastage(ticket)
                                      }
                                    }
                                  },
                                  [_vm._v("Add Wastage")]
                                )
                              ])
                        ])
                      : _vm._e()
                  ])
                })
              )
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("section", [
      _vm.editing
        ? _c("div", [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", [
                  _c("h4", [
                    _vm._v(
                      "Applying wastage - " +
                        _vm._s(_vm.current_ticket.ticket_data.lang.en_GB.title)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "container " }, [
                  !_vm.current_wastage.applied
                    ? _c("div", [
                        _c("section", [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("span", [
                                _vm._v("Allocated (with no wastage):")
                              ]),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.current_ticket.allocated))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col" }, [
                              _c("span", [
                                _vm._v("Allocated (after wastage):")
                              ]),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.current_ticket.allocated -
                                      _vm.current_wastage.amount
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col" }, [
                              _c("span", [_vm._v("Remaining spaces:")]),
                              _vm._v(" "),
                              _c("strong", [_vm._v(_vm._s(_vm.remaining))])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("section", [
                          _c("div", { staticClass: "row mt-5" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("form", [
                                _c("strong", [
                                  _vm._v("Amount of spaces wasted")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.current_wastage.amount,
                                      expression: "current_wastage.amount"
                                    }
                                  ],
                                  staticClass: "border-0",
                                  attrs: {
                                    type: "number",
                                    min: _vm.current_wastage.min,
                                    max: _vm.current_ticket.allocated,
                                    step: "1"
                                  },
                                  domProps: {
                                    value: _vm.current_wastage.amount
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.current_wastage.amount >
                                      _vm.current_ticket.allocated
                                        ? (_vm.current_wastage.amount =
                                            _vm.current_ticket.allocated)
                                        : null
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.current_wastage,
                                        "amount",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "md-form range-field" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.current_wastage.amount,
                                          expression: "current_wastage.amount"
                                        }
                                      ],
                                      attrs: {
                                        type: "range",
                                        min: _vm.current_wastage.min,
                                        max: _vm.current_ticket.allocated
                                      },
                                      domProps: {
                                        value: _vm.current_wastage.amount
                                      },
                                      on: {
                                        __r: function($event) {
                                          _vm.$set(
                                            _vm.current_wastage,
                                            "amount",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "md-form" }, [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.current_wastage.notes,
                                      expression: "current_wastage.notes"
                                    }
                                  ],
                                  staticClass: "md-textarea",
                                  attrs: {
                                    id: "textarea-char-counter",
                                    length: "512"
                                  },
                                  domProps: {
                                    value: _vm.current_wastage.notes
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.current_wastage,
                                        "notes",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "textarea-char-counter" } },
                                  [_vm._v("Wastage notes:")]
                                )
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("section", [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.current_wastage.expire_date,
                                      expression: "current_wastage.expire_date"
                                    }
                                  ],
                                  staticClass: "border-0",
                                  attrs: {
                                    type: "checkbox",
                                    id: "enabled--expire-date",
                                    checked: ""
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.current_wastage.expire_date
                                    )
                                      ? _vm._i(
                                          _vm.current_wastage.expire_date,
                                          null
                                        ) > -1
                                      : _vm.current_wastage.expire_date
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.current_wastage.expire_date,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.current_wastage,
                                              "expire_date",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.current_wastage,
                                              "expire_date",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.current_wastage,
                                          "expire_date",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "enabled--expire-date" } },
                                  [_vm._v("Enable expire date")]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.current_wastage.expire_date
                              ? _c("div", { staticClass: "col-4" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.current_wastage.time,
                                        expression: "current_wastage.time"
                                      }
                                    ],
                                    staticClass: "border-0",
                                    attrs: { type: "time" },
                                    domProps: {
                                      value: _vm.current_wastage.time
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.current_wastage,
                                          "time",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.current_wastage.expire_date
                              ? _c("div", { staticClass: "col-4" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.current_wastage.date,
                                        expression: "current_wastage.date"
                                      }
                                    ],
                                    attrs: { type: "date" },
                                    domProps: {
                                      value: _vm.current_wastage.date
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.current_wastage,
                                          "date",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("section", [
                          _c("div", { staticClass: "row" }, [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.current_wastage.wastage_reason_id,
                                      expression:
                                        "current_wastage.wastage_reason_id"
                                    }
                                  ],
                                  staticStyle: { display: "block !important" },
                                  attrs: {
                                    id: "select_wastage_reason",
                                    name: "wastage_reason_id"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.current_wastage,
                                        "wastage_reason_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.wastage_reasons, function(
                                  wastage_reason
                                ) {
                                  return _c(
                                    "option",
                                    { domProps: { value: wastage_reason.id } },
                                    [
                                      _vm._v(
                                        _vm._s(wastage_reason.lang.en_GB.title)
                                      )
                                    ]
                                  )
                                })
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col" }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getWastageReasonDetails(
                                      _vm.current_wastage.wastage_reason_id
                                    )
                                  )
                                )
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("section", [
                          _vm.remaining < 0
                            ? _c("div", { staticClass: "row mt-5" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c("div", { staticClass: "container" }, [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col text-center" },
                                        [
                                          _c(
                                            "strong",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                "We need to move\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(-_vm.remaining) +
                                                  " sale(s)"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(
                                              ": " +
                                                _vm._s(
                                                  _vm.getRemainingWithEntitiesAmount()
                                                ) +
                                                " remaining"
                                            )
                                          ])
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm._m(2),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _c("table", { staticClass: "table" }, [
                                        _vm._m(3),
                                        _vm._v(" "),
                                        _c(
                                          "tbody",
                                          _vm._l(_vm.possible_tickets, function(
                                            ticket
                                          ) {
                                            return _c("tr", [
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    ticket.ticket_data.lang
                                                      .en_GB.title
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(ticket.sales))
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(ticket.allocated))
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getAvailableSpaces(
                                                      ticket
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: ticket.transfer,
                                                      expression:
                                                        "ticket.transfer"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "number",
                                                    min: 0,
                                                    max: _vm.getMaxTransferForTicket(
                                                      ticket
                                                    ),
                                                    step: "1"
                                                  },
                                                  domProps: {
                                                    value: ticket.transfer
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      ticket.transfer >
                                                      _vm.getMaxTransferForTicket(
                                                        ticket
                                                      )
                                                        ? (ticket.transfer = _vm.getMaxTransferForTicket(
                                                            ticket
                                                          ))
                                                        : null
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        ticket,
                                                        "transfer",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ])
                                            ])
                                          })
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("section", [
                    _vm.current_wastage.applied
                      ? _c("div", [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c("h5", [
                                _c("b", [
                                  _vm._v(
                                    "Wastage of " +
                                      _vm._s(_vm.current_wastage.amount) +
                                      " spaces applied"
                                  )
                                ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.current_wastage.moved.length > 0
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c("table", { staticClass: "table" }, [
                                    _vm._m(4),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.current_wastage.moved,
                                        function(sale) {
                                          return _c("tr", [
                                            _c("td", [
                                              _vm._v(_vm._s(sale.first_name))
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(sale.last_name))
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(sale.email))
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(sale.telephone))
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(sale.reference))
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(sale.ticket_name))
                                            ])
                                          ])
                                        }
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-large btn-primary",
                                      on: {
                                        click: function($event) {
                                          _vm.exportList()
                                        }
                                      }
                                    },
                                    [_vm._v("Export List")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-large btn-primary",
                                      on: {
                                        click: function($event) {
                                          _vm.sendEmails()
                                        }
                                      }
                                    },
                                    [_vm._v("Send Emails to all users")]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-large btn-primary",
                                  on: {
                                    click: function($event) {
                                      _vm.close()
                                    }
                                  }
                                },
                                [_vm._v("Done")]
                              )
                            ])
                          ])
                        ])
                      : _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-large btn-primary",
                                on: {
                                  click: function($event) {
                                    _vm.cancel_wastage()
                                  }
                                }
                              },
                              [_vm._v("Cancel wastage")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-large btn-primary",
                                on: {
                                  click: function($event) {
                                    _vm.submit_wastage()
                                  }
                                }
                              },
                              [_vm._v("Apply wastage")]
                            )
                          ])
                        ])
                  ])
                ])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h5", [_vm._v("Expiration date for all future created tickets")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("label", { attrs: { for: "select_wastage_reason" } }, [
        _vm._v("Select a wastage reason")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-success" }, [
      _c("span", [_vm._v("We are going to move sales with order:")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("Latest sales not refunded")]),
        _vm._v(" "),
        _c("li", [_vm._v("Latest sales refunded")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Ticket")]),
        _vm._v(" "),
        _c("th", [_vm._v("Sold")]),
        _vm._v(" "),
        _c("th", [_vm._v("Allocated")]),
        _vm._v(" "),
        _c("th", [_vm._v("Available Spaces")]),
        _vm._v(" "),
        _c("th", [_vm._v("Move Spaces")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("First Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Last Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Email")]),
        _vm._v(" "),
        _c("th", [_vm._v("Telephone")]),
        _vm._v(" "),
        _c("th", [_vm._v("Sale Reference")]),
        _vm._v(" "),
        _c("th", [_vm._v("Transferred to new ticket")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a05d096", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a05d096","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/pages/wastage/WastagePage.vue
// module id = 393
// module chunks = 0